import { Icon } from "../components/Icon.js";

export function AuditLogPage() {
  return (
    <div className="bg-surface-container border border-outline-variant rounded-xl p-xl flex flex-col items-center text-center gap-md min-h-[420px] justify-center">
      <Icon name="history" className="text-primary-fixed-dim/60" style={{ fontSize: "56px" }} />
      <h1 className="text-display-xl text-on-background">Audit log</h1>
      <p className="max-w-md text-body-base text-on-surface-variant">
        Every event create / update / delete will be appended here for 365 days (NFR-5). The backend `change_log`
        table is in place; the read API will be wired once events start flowing.
      </p>
      <span className="font-mono text-label-xs uppercase tracking-widest text-on-surface-variant border border-outline-variant rounded-lg px-3 py-1.5 mt-2">
        Activates with first sync
      </span>
    </div>
  );
}
